"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReceivePeerState = void 0;
const react_1 = require("react");
function useReceivePeerState(peerBrokerId, opts) {
    const { brokerId: brokerIdOption } = Object.assign({ brokerId: '' }, opts);
    const [state, setState] = (0, react_1.useState)(undefined);
    const [isConnected, setIsConnected] = (0, react_1.useState)(false);
    const [peer, setPeer] = (0, react_1.useState)(undefined);
    const [brokerId, setBrokerId] = (0, react_1.useState)(brokerIdOption);
    const [error, setError] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        if (!peerBrokerId || peer) {
            return;
        }
        const connectToPeer = () => __awaiter(this, void 0, void 0, function* () {
            const peerjs = yield Promise.resolve().then(() => __importStar(require('peerjs')));
            const { default: PeerConstructor } = peerjs;
            const localPeer = new PeerConstructor(brokerIdOption);
            setPeer(localPeer);
            localPeer.on('open', () => {
                if (brokerId !== localPeer.id) {
                    setBrokerId(localPeer.id);
                }
                const connection = localPeer.connect(peerBrokerId);
                connection.on('open', () => {
                    connection.on('data', (receivedData) => {
                        setState(receivedData);
                        setIsConnected(true);
                    });
                });
                connection.on('close', () => {
                    setIsConnected(false);
                });
                connection.on('error', (err) => setError(err));
            });
            localPeer.on('error', (err) => setError(err));
        });
        void connectToPeer();
    }, [peerBrokerId, brokerIdOption, brokerId, peer]);
    (0, react_1.useEffect)(() => () => {
        setIsConnected(false);
        peer === null || peer === void 0 ? void 0 : peer.destroy();
    }, [peer]);
    return [state, isConnected, error];
}
exports.useReceivePeerState = useReceivePeerState;
